import * as React from 'react'
import { NumberInput, RadioInput } from '@ztechapps/webui.input'
import { SaveCancelButtons } from '@ztechapps/webui.button'
import { Icon, ShowIf } from '@ztechapps/webui.util'
import { DiscountSelect } from './DiscountSelect'
import { jsonTryParse, roundNumber } from '@ztechapps/common.utils'
import { Card, InputGroup } from 'react-bootstrap'
import toNumber from 'lodash/toNumber'

export const DiscountEditContent = ({
  setNewValue,
  value,
  gross,
  onBlur,
  cancelNow,
  submitting,
}: {
  setNewValue?: (value: any) => void
  value?: Record<any, any>
  gross?: number
  onBlur?: () => Promise<any>
  cancelNow?: () => void
  submitting?: boolean
}) => {
  const [radioButtonValue, setRadioButtonValue] = React.useState('amount')

  const [isAmount, setIsAmount] = React.useState<boolean>(true)

  const computeValue = (value: number, isAmount: boolean) => {
    if (isAmount) {
      setNewValue({
        amount: value,
        percent: roundNumber((value / gross) * 100, 4),
      })
    } else {
      setNewValue({
        amount: roundNumber(gross * (value / 100), 4),
        percent: value,
      })
    }
  }

  return (
    <Card>
      <Card.Body>
        <ShowIf condition={radioButtonValue !== 'presets'}>
          <InputGroup>
            <NumberInput
              submitting={submitting}
              value={isAmount ? value?.amount : value?.percent}
              onChange={(e) => {
                computeValue(toNumber(e?.target?.value), isAmount)
              }}
            />
            <InputGroup.Text>
              <Icon name={isAmount ? 'dollar' : 'percent'} />
            </InputGroup.Text>
          </InputGroup>
        </ShowIf>

        <ShowIf condition={radioButtonValue === 'presets'}>
          <DiscountSelect
            isDisabled={submitting}
            onChange={(e: any) => {
              const parsedValue = jsonTryParse(e?.value)
              setIsAmount(!!parsedValue?.isAmount)
              computeValue(parsedValue?.value, parsedValue?.isAmount)
            }}
          />
        </ShowIf>

        <div className={'my-2'}>
          <RadioInput
            submitting={submitting}
            inline
            checked={radioButtonValue === 'amount'}
            name={'discount_amount'}
            label={'Amount'}
            onChange={() => {
              setRadioButtonValue('amount')
              setIsAmount(true)
            }}
          />

          <RadioInput
            submitting={submitting}
            inline
            checked={radioButtonValue === 'percent'}
            name={'discount_percent'}
            label={'Percent'}
            onChange={() => {
              setRadioButtonValue('percent')
              setIsAmount(false)
            }}
          />

          <RadioInput
            submitting={submitting}
            inline
            checked={radioButtonValue === 'presets'}
            name={'discount_presets'}
            label={'Presets'}
            onChange={() => {
              setRadioButtonValue('presets')
            }}
          />
        </div>

        <div className={'mt-3'}>
          <SaveCancelButtons onSave={onBlur} onCancel={cancelNow} isBusy={submitting} />
        </div>
      </Card.Body>
    </Card>
  )
}
